import { CONFIG_LS_UPDATE } from 'Reducers/lsConfig/types';
import { setUrls, urls } from 'Utilities/dataHelpers';
import * as log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { setSessionObject } from 'Utilities/storage';
import { store } from 'Utilities/store';
export const getConfig = (country, pId) => {
  return new Promise((resolve, reject) => {
    if (!urls.libreSharingApiUrl) {
      throw new Error('Missing LSAPI base URL');
    }
    const url = `${urls.libreSharingApiUrl}v1/config`;
    mediator.request('api:ls:invoke', {
      method: 'GET',
      url,
      params: {
        country,
        pId
      }
    }).then(result => {
      if (result?.data) {
        return resolve(result.data);
      }
      reject(result);
    }).catch(err => {
      log.error(err);
      reject(err);
    });
  });
};
export const updateConfig = async (countryParam = 'US', pId = '', redirect_uri = '', cid = '') => {
  try {
    const country = countryParam.toUpperCase();
    const config = await getConfig(country, pId);
    setUrls(config, country);
    store.dispatch({
      type: CONFIG_LS_UPDATE,
      lsConfig: config
    });
    setSessionObject('lsConfig', config);
    setSessionObject('lsEnv', {
      country,
      pId,
      redirect_uri,
      cid
    });
  } catch (e) {
    // This has no down stream impacts for now, but it will once we implement forgot password and create account with lsapi
    log.error('Error getting and setting lsapi config', e);
  }
};